export class HistoricalYieldFees {
  constructor(
    public label: string,
    public yieldValue: number,
    public fee: number,
    public netRevenue: number
  ) {}
}
